export enum ScannedAddressStatus {
  skipped = 'Skipped',
  addedAsAdditional = 'AddedAsAdditional',
  replaced = 'Replaced',
  addedAsMain = 'AddedAsMain',
}
